var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 2.66699C3.71334 2.66699 2.66667 3.71366 2.66667 5.00033C2.66667 6.28699 3.71334 7.33366 5.00001 7.33366C6.28667 7.33366 7.33334 6.28699 7.33334 5.00033C7.33334 3.71366 6.28667 2.66699 5.00001 2.66699ZM5.00001 6.00033C4.44667 6.00033 4.00001 5.55366 4.00001 5.00033C4.00001 4.44699 4.44667 4.00033 5.00001 4.00033C5.55334 4.00033 6 4.44699 6 5.00033C6 5.55366 5.55334 6.00033 5.00001 6.00033ZM11 8.66699C9.71334 8.66699 8.66667 9.71366 8.66667 11.0003C8.66667 12.287 9.71334 13.3337 11 13.3337C12.2867 13.3337 13.3333 12.287 13.3333 11.0003C13.3333 9.71366 12.2867 8.66699 11 8.66699ZM11 12.0003C10.4467 12.0003 10 11.5537 10 11.0003C10 10.447 10.4467 10.0003 11 10.0003C11.5533 10.0003 12 10.447 12 11.0003C12 11.5537 11.5533 12.0003 11 12.0003ZM3.60667 13.3337L2.66667 12.3937L12.3933 2.66699L13.3333 3.60699L3.60667 13.3337Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/Percent.1f14be76f5df24fbe0f6971e1e49f8f1.svg";
export { ForwardRef as ReactComponent };